import * as SearchHistory from "./searchHistory";
let _searchfield: JQuery<Node>;

// #region Exports

export function initialize(): void {
    _searchfield = $('#searchfield');

    wireEvents();
}

// #endregion Exports

function wireEvents() {
    _searchfield.on('keydown', handleKeyDown);

    $('#searchfieldbutton').on('click', handleFormPost);
}

function handleKeyDown(e:JQuery.Event) {
    if (e.keyCode === 13) {
        _searchfield.removeAttr('required');
        if (submitViaSearchForm()) {
            e.preventDefault();
        }
    }
}

function handleFormPost(e:JQuery.Event) {
    _searchfield.removeAttr('required');
    if (submitViaSearchForm()) {
        e.preventDefault();
    }
}

function submitViaSearchForm(): boolean {
    const $searchForm = $('#searchform');
    if ($searchForm.length === 0) {
        return false;
    }

    const query = _searchfield.val() as string;
    $searchForm.find('input[name="q"]').val(query);

    sessionStorage.setItem('runSearchHistoryUpdate', 'true');

    $searchForm.trigger('submit');
    return true;
}

document.addEventListener('DOMContentLoaded', () => {
    if (sessionStorage.getItem('runSearchHistoryUpdate') === 'true') {
        sessionStorage.removeItem('runSearchHistoryUpdate');
        SearchHistory.update();
    }
});